// Copyright (c) Docugami, Inc. All rights reserved.

import { createListenerMiddleware, addListener } from '@reduxjs/toolkit'
import type { TypedStartListening, TypedAddListener } from '@reduxjs/toolkit'
import { AppState, AppDispatch } from 'store'

export const listenerMiddleware = createListenerMiddleware()

export type AppStartListening = TypedStartListening<AppState, AppDispatch>

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening

export const addAppListener = addListener as TypedAddListener<
  AppState,
  AppDispatch
>
